module.exports = __webpack_public_path__ + "static/media/FILAS_DE_ATENDIMENTO.1f35334c.png";